// 登录页面
export default {
    rememberPassword: 'Remember me',
    enterName: 'Please enter user name',
    enterPassword: 'Please enter password',
    forget: 'Forget the password?',
    login: 'Login',
    loggingIn: 'Logging in',
    userLogin: 'User login',
    loginSuccess: 'Login successfully',
    VCL: 'Verification code login',
    PEPN: 'Please enter phone number',
    VC: 'Verification code',
    FR: 'Registration',
    FP: 'Forget password',
    GVC: 'Get verification code',
    changePassword: 'Change Password',
    tip_PEVC: 'Please enter verification code',
    tip_IVC: 'Incorrect verification code',
    tip_MPN: 'Malformed phone number',
    tip_VCFE: 'Verification code format error',
    tip_PCYP: 'Please confirm your password',
    tip_P: 'Must contain uppercase and lowercase letters and numbers, special characters can be used, and the length is between 8-20',
    tip_TT: 'The two passwords are not consistent!',
    tip_N: 'Chinese, English, numbers but not including underscore and other symbols',
    tip_RS: 'Registration success',
    tip_PRS: 'Password reset successfully',
    tip_PET: 'Please enter the old password',
    tip_PEA: 'Please enter a new password',
    tip_PIU: 'Please input Username',
    generalUser: 'General User',
    businessUser: 'Business User',
}